// extracted by mini-css-extract-plugin
module.exports = {"content":"DevelopersAPIButtonsContent_content__2PMQ2","buttons":"DevelopersAPIButtonsContent_buttons__FSDbB","createButton":"DevelopersAPIButtonsContent_createButton__eZiIR"};